import React from 'react'
import { Label, coreUtils } from '@adc/ui-morpheus'
const { ColorHash } = coreUtils
const colorHash = new ColorHash()

/**
 * Renders one dropdown option
 * @param  {string} label           Label of option
 */
const renderResult = label => (
  <div>
    <Label
      style={{
        backgroundColor: colorHash.hex(label),
        color: '#fff',
      }}
      content={label}
    />
  </div>
)

/**
 * Renders role options
 * @param  {Array} roleDefs   Array of roledef objects
 */
export const renderOptions = (roleDefs = []) =>
  roleDefs.map(item => ({
    value: item.code,
    text: item.display_name,
    content: renderResult(item.display_name),
  }))

/**
 * Renders suggestion options
 * @param  {Array} roleDefs   Array of roledef objects
 */
export const renderSuggestions = (roleDefs = []) =>
  roleDefs.map(item => ({
    value: item.code,
    text: item.display_name,
    content: renderResult(item.display_name),
  }))

/**
 * This is to emulate what we'd otherwise (typically) get from a one time async suggestion fetch,
 * however in this case we grab it from the store and construct the suggestion options here.
 */
export const prepPartyRoleSuggestions = roleDefs => ({
  'roles.role_name': renderSuggestions(roleDefs),
})
